export default __webpack_public_path__ + "static/media/rdg.f20304f6.svg";